/* eslint-disable object-curly-newline */
import Icon from '@material-ui/core/Icon';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Tooltip } from '@mui/material';
import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { colors } from '../../../utils';
import {
	Flex,
	MainMenuList,
	MainMenuListIcon,
	MainMenuListLabel,
	MainMenuListLink,
	ResSubMenuList,
	SubMenu,
	SubMenuList,
	SubMenuListIcon,
	SubMenuListLabel,
	SubMenuListLink,
} from './styledComponents';

const styles = {
	btn: {
		backgroundColor: "transparent",
		color: "white"
	}
}


const { primaryText, colorPrimary } = colors;

const LightTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: '#333',
		color: primaryText,
		boxShadow: theme.shadows[1],
		fontSize: 11,
	},
}));

// eslint-disable-next-line no-unused-vars
function DrawerList({
	drawer,
	iconStyle,
	name,
	to,
	subMenus,
	subMenus2,
	menuIcon,
	tooltipText,
	html,
	// setDrawer,
}) {
	const [expandMenu, setExpandMenu] = useState(false);
	const [expandNestedMenu, setExpandNestedMenu] = useState([]);
	const [anchorEl, setAnchorEl] = useState(null);
	const ref = useRef();
	const ref2 = useRef();

	// const Icon = Icons[menuIcon];

	// console.log('top', Icons[menuIcon]);
	const handleClick = (event) => {
		setAnchorEl(anchorEl ? null : event.currentTarget);
	};

	const handlenestedSubMenus = (ind) => {

		const isOpen = expandNestedMenu.includes(ind);
		if (isOpen) {
			setExpandNestedMenu(expandNestedMenu.filter((item) => item !== ind));
		} else {
			setExpandNestedMenu([...expandNestedMenu, ind]);
		}
	};

	const open = Boolean(anchorEl);
	const id = open ? 'simple-popper' : undefined;

	useEffect(() => {
		const checkIfClickedOutside = (e) => {
			// If the menu is open and the clicked target is not within the menu,
			// then close the menu
			if (anchorEl && ref.current && !ref.current.contains(e.target)) {
				setAnchorEl(null);
			}
		};
		document.addEventListener('click', checkIfClickedOutside);
		return () => {
			// Cleanup the event listener
			document.removeEventListener('click', checkIfClickedOutside);
		};
	}, [anchorEl]);

	return (
		// Main Menu List Open 1
		<MainMenuList>
			{/* <MainMenuList onClick={() => drawer && setExpandMenu(!expandMenu)}> */}
			{/* Main Menu List Link Open */}
			{to ? (
				<Link to={to}>
					<MainMenuListLink jc='space-between'>
						{/* Main Menu List Icon Open */}
						<Flex jc='flex-start'>
							<LightTooltip title={tooltipText} placement='right-start'>
								<MainMenuListIcon>
									<Icon
										style={{
											fontSize: '2.1rem',
											position: 'relative',
											top: '0.2rem',
											color: colorPrimary,
										}}>
										{menuIcon}
									</Icon>
								</MainMenuListIcon>
							</LightTooltip>
							{/* Main Menu List Icon End */}
							{/* Main Menu List Label Open */}
							{drawer && (
								<MainMenuListLabel className='font-face-R'>
									{name}
								</MainMenuListLabel>
							)}
							{/* Main Menu List Label Open */}
						</Flex>
						{subMenus.length > 0 && drawer && (
							<div>
								{!expandMenu ? (

									<KeyboardArrowDownIcon sx={iconStyle} />

								) : (
									<KeyboardArrowUpIcon sx={iconStyle} />
								)}
							</div>
						)}
					</MainMenuListLink>
				</Link>
			) : (
				<MainMenuListLink jc='space-between' onClick={() => drawer && setExpandMenu(!expandMenu)}>
					{/* Main Menu List Icon Open */}
					<Flex jc='flex-start'>
						<LightTooltip title={tooltipText} placement='right-start'>
							<MainMenuListIcon
								aria-describedby={id}
								type='button'
								onClick={handleClick}
								ref={ref}>
								<Icon
									style={{
										fontSize: '2.1rem',
										position: 'relative',
										top: '0.2rem',
										color: colorPrimary,
									}}>
									{/* playlist_add_check_circle_icon */}
									{menuIcon}
								</Icon>
							</MainMenuListIcon>
						</LightTooltip>
						{/* Main Menu List Icon End */}
						{/* Main Menu List Label Open */}
						{drawer && (
							<>
								<MainMenuListLabel className='font-face-R'>
									{name}
								</MainMenuListLabel>
								{html && html > 0 ? (
									<div
										style={{
											fontSize: '1rem',
											padding: '0.5rem',
											backgroundColor: '#fff',
											color: colorPrimary,
											borderRadius: '50%',
											width: '15px',
											height: '15px',
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											fontWeight: '700',
											marginLeft: '0.5rem',
										}}>
										{html}
									</div>
								) : (
									''
								)}
							</>
						)}
						{/* Main Menu List Label Open */}
					</Flex>
					{subMenus.length > 0 && drawer && (
						<div>
							{!expandMenu ? (
								<KeyboardArrowDownIcon sx={iconStyle} />
							) : (
								<KeyboardArrowUpIcon sx={iconStyle} />
							)}
						</div>
					)}
					{subMenus2.length > 0 && drawer && (
						<div>
							{!expandMenu ? (
								<KeyboardArrowDownIcon sx={iconStyle} />
							) : (
								<KeyboardArrowUpIcon sx={iconStyle} />
							)}
						</div>
					)}
				</MainMenuListLink>
			)}
			{/* Main Menu List Link End */}
			{/* Sub Menu Toggle  */}
			{expandMenu && subMenus.length > 0 && drawer && (
				<SubMenu>
					{subMenus.map((list) => (
						<SubMenuList key={list.name}>
							<Link to={list.to}>
								<SubMenuListLink>
									<SubMenuListIcon className='subMenuListIcon'>
										<Icon
											style={{
												fontSize: '2.1rem',
												position: 'relative',
												top: '0.2rem',
												color: colorPrimary,
											}}>
											{list.menuIcon}
										</Icon>
									</SubMenuListIcon>
									<SubMenuListLabel className='font-face-R'>
										{list.name}
									</SubMenuListLabel>
									{list?.html ? (
										<div
											style={{
												fontSize: '1rem',
												padding: '0.5rem',
												backgroundColor: '#fff',
												color: colorPrimary,
												borderRadius: '50%',
												width: '15px',
												height: '15px',
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center',
												fontWeight: '700',
												marginLeft: '0.5rem',
											}}>
											{list.html}
										</div>
									) : (
										''
									)}
								</SubMenuListLink>
							</Link>
						</SubMenuList>
					))}
				</SubMenu>
			)}











			{expandMenu && subMenus2 && subMenus2?.length > 0 && subMenus2.map((val, index) => {
				return <>

					<MainMenuListLink jc='space-between' onClick={() => handlenestedSubMenus(index)}>
						<Flex jc='flex-start'>
							<LightTooltip title={val.tooltipText} placement='right-start'>
								<MainMenuListIcon
									aria-describedby={id}
									type='button'
									onClick={handleClick}
									ref={ref2}
								>
									<Icon
										style={{
											fontSize: '2.1rem',
											position: 'relative',
											top: '0.2rem',
											color: colorPrimary,
										}}>
										{val.menuIcon}
									</Icon>
								</MainMenuListIcon>
							</LightTooltip>
							{drawer && (
								<>
									<MainMenuListLabel className='font-face-R'>
										{val.name}
									</MainMenuListLabel>
									{html && html > 0 ? (
										<div
											style={{
												fontSize: '1rem',
												padding: '0.5rem',
												backgroundColor: '#fff',
												color: colorPrimary,
												borderRadius: '50%',
												width: '15px',
												height: '15px',
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center',
												fontWeight: '700',
												marginLeft: '0.5rem',
											}}>
											{html}
										</div>
									) : (
										''
									)}
								</>
							)}
						</Flex>

						{val.subMenus && val.subMenus.length > 0 && drawer && (
							<>
								<div>
									{!expandNestedMenu.includes(index) ? (
										<KeyboardArrowDownIcon sx={iconStyle} />
									) : (
										<KeyboardArrowUpIcon sx={iconStyle} />
									)}



								</div>
							</>

						)}
					</MainMenuListLink>
					{expandNestedMenu.includes(index) &&
						<SubMenu>
							<SubMenuList key={val.name}>
								{val.subMenus.map((list) => (
									<Link to={list.to}>
										<SubMenuListLink>
											<SubMenuListIcon className='subMenuListIcon'>
												<Icon
													style={{
														fontSize: '2.1rem',
														position: 'relative',
														top: '0.2rem',
														color: colorPrimary,
													}}>
													{list.menuIcon}
												</Icon>
											</SubMenuListIcon>
											<SubMenuListLabel className='font-face-R'>
												{list.name}
											</SubMenuListLabel>
											{list?.html ? (
												<div
													style={{
														fontSize: '1rem',
														padding: '0.5rem',
														backgroundColor: '#fff',
														color: colorPrimary,
														borderRadius: '50%',
														width: '15px',
														height: '15px',
														display: 'flex',
														justifyContent: 'center',
														alignItems: 'center',
														fontWeight: '700',
														marginLeft: '0.5rem',
													}}>
													{list.html}
												</div>
											) : (
												''
											)}
										</SubMenuListLink>
									</Link>
								))}
							</SubMenuList>
						</SubMenu>}
				</>
			})}


















			{/* Responsive Sub Menu Open */}
			{open && subMenus.length > 0 && !drawer && (
				<Popper
					id={id}
					open={open}
					anchorEl={anchorEl}
					style={{
						backgroundColor: '#333333',
						borderRadius: '0.4rem',
						padding: '0.5rem',
						zIndex: 111,
					}}>
					{subMenus.map((list) => (
						<ResSubMenuList key={list.name}>
							<Link to={list.to}>
								<SubMenuListLink>
									<SubMenuListIcon className='subMenuListIcon'>
										{list.menuIcon}
									</SubMenuListIcon>
									<SubMenuListLabel>{list.name}</SubMenuListLabel>
								</SubMenuListLink>
							</Link>
						</ResSubMenuList>
					))}
				</Popper>
			)}
			{/* Responsive Sub Menu End */}

		</MainMenuList>
		//   Main Menu List 1 End
	);
}

export default DrawerList;
